<template>
  <div class="selection-modal" v-if="show">
    <div class="selected-images-grid">
      <ul class="selected-images">
        <li 
          v-for="(item, index) in selectedImages" 
          :key="index"
          class="selected-image-item"
          :class="{ 'incorrect': item.isIncorrect }"
        >
          <el-image 
            :src="item.src" 
            fit="cover"
            class="selected-image"
            :preview-src-list="[item.src]"
          />
        </li>
      </ul>
    </div>

    <!-- <div v-if="isComplete" class="modal-footer">
      <button class="continue-button" @click="handleContinue">Go on</button>
    </div> -->
  </div>
</template>

<script>
import { Image as ElImage } from 'element-ui';

export default {
  name: 'SelectionModal',
  components: {
    ElImage
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedImages: {
      type: Array,
      default: () => []
    },
    isComplete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countdown: 2,
      timer: null
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.startCountdown();
      } else {
        this.clearTimer();
      }
    }
  },
  methods: {
    startCountdown() {
      this.countdown = 2;
      this.clearTimer();
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.handleContinue();
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    close() {
      this.clearTimer();
      this.$emit('close');
    },
    handleContinue() {
      this.clearTimer();
      if (this.isComplete) {
        // If all images are selected, emit submit event
        this.$emit('submit');
      } else {
        // Otherwise just close the modal to continue selection
        this.$emit('close');
      }
    }
  }
}
</script>

<style scoped>
.selection-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #CCCFFF;
  display: flex;
  flex-direction: column;
  z-index: 1000;
}

.selected-images-grid {
  box-sizing: border-box;
  flex: 1;
  margin-top: 20px;
  overflow-y: auto;
}
.selected-images-grid::-webkit-scrollbar {
  display: none;
}

.selected-images {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  min-height: 100%;
  margin: 0;
  margin-left: -1%;
  padding: 0 20px;
}
.selected-image-item {
  box-sizing: border-box;
  width: 24%;
  height: 180px;
  margin-bottom: 20px;
  margin-left: 1%;
  border: 4px solid #48FF00;
  border-radius: 12px;
  overflow: hidden;
}

.selected-image-item.incorrect {
  border-color: #ff5252;
}

.selected-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-footer {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 20px;
  gap: 20px;
}

.countdown {
  color: #666;
  font-size: 16px;
}

.continue-button {
  background: rgba(141, 201, 89, 1);
  box-shadow:inset 0px -2px 5px  rgba(42, 135, 47, 0.57), 0px 1px 4px  rgba(0, 0, 0, 0.45);
  color: white;
  border: none;
  border-radius: 30px;
  padding: 12px 40px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s;
}

.continue-button:hover {
  background-color: #45a049;
}
</style>
